import { render, staticRenderFns } from "./CountdownDialog.vue?vue&type=template&id=58800a94&scoped=true&"
import script from "./CountdownDialog.vue?vue&type=script&lang=js&"
export * from "./CountdownDialog.vue?vue&type=script&lang=js&"
import style0 from "./CountdownDialog.vue?vue&type=style&index=0&id=58800a94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58800a94",
  null
  
)

export default component.exports